import midbannerimage from "../../assets/track-what-matters.svg"
import "./midbanner.css"
const MidBannerSection = () => {
  return (
    <section className='mid-banner-section'>
        <div className='container'>
            <div className='mid-banner-wrapper row'>
            <div className='col-12 col-lg-6 col-md-6 col-sm-6'>
                <div className="mid-image-banner">
                <img src={midbannerimage} alt="mid-banner-image"/>
                </div>
            </div>
            <div className='col-12 col-lg-6 col-md-6 col-sm-6'>
                <div className="mid-banner-content">
                    <h2>Track What Matters: SLOs, SLIs, and SLAs Automated</h2>
                    <div>
                        <h3>Automated SLI Tracking</h3>
                        <p>Guide your AI journey from discovery to deployment, ensuring every solution aligns with your business goals</p>
                    </div>
                     <div>
                        <h3>SLO Enforcement</h3>
                        <p>Accelerate transformation using modular, orchestrated AI agents built for real-world business outcomes</p>
                    </div>
                     <div>
                        <h3>SLA Protection</h3>
                        <p>Embed compliance, transparency, and ethical safeguards into every AI-driven process</p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>
  )
}

export default MidBannerSection